import { computed, toValue } from "vue";
import { ORDER_STATUS } from "@/constants";
import { pastSessionDeadline, pastSessionStartDate } from "@/util/pastSessionDeadline";

export const usePastApplicationDeadline = (application: Record<string, any>) => {
  const session = computed<Record<string, any>>(() => toValue(application.session));

  const orderStatus = computed<string>(() => {
    const currentOrder = toValue(application.primaryOrder);
    if (!currentOrder) {
      return ORDER_STATUS.draft;
    }
    return currentOrder.status;
  });

  const isPastSessionDeadline = computed<boolean>(() => pastSessionDeadline(session.value));

  const isPastSessionStartDate = computed<boolean>(() => pastSessionStartDate(session.value));

  const isPastDeadline = computed<boolean>(() => {
    return orderStatus.value === ORDER_STATUS.draft && isPastSessionDeadline.value;
  });

  return {
    isPastDeadline,
    isPastSessionDeadline,
    isPastSessionStartDate,
  };
};
